import React, { useContext, useEffect } from "react";
import { getRMNDataRequest } from "../Redux/API";
import { AppContext } from "../Redux/ContextProvider";
import { ClipLoader } from "react-spinners";
import Breadcrumb from "../Generic/Breadcrumb";
import RMNCard from "./RMNCard";

function Rmn() {
  const { appState, dispatch } = useContext(AppContext);

  let data = {
    ClientId: 48,
    StoreId: 1,
  };

  const { RMNData, RMNLoader } = appState;

  useEffect(() => {
    getRMNDataRequest(appState, dispatch, data);
  }, []);

  return (
    <>
      {RMNLoader ? (
        <div className="home-spinner">
          <ClipLoader color={"#2A5350"} loading={true} size={60} />
        </div>
      ) : (
        Object.keys(RMNData).length > 0 && (
          <>
            <Breadcrumb
              pageName={RMNData?.data?.header_team_section.title || "Retail Media Opportunities"}
              pageTitle={RMNData?.data?.header_team_section.title || "Retail Media Opportunities"}
              id={`#${RMNData?.data?.header_team_section.title}`}
              image={RMNData?.data?.header_team_section.banner_image}
            //   myRef={myRef}
            />
            <div
              className="team-section2 mb-50"
            // ref={myRef}
            data-aos="fade-up"
            >
              <div className="container">
                      <span>{RMNData?.data?.header_team_section.title}</span>
                {RMNData?.data?.section?.map((section) => {
                  return <RMNCard service={section} />;
                })}
              </div>
            </div>
          </>
        )
      )}
    </>
  );
}

export default Rmn;
